module.exports = __webpack_public_path__ + "static/media/37.487974de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/37.jpg
// module id = 598
// module chunks = 0